import {call, put} from 'redux-saga/effects';
import CarErrorsActions from '../redux/CarErrorsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getCarErrors(api, action) {
  const response = yield call(api.getCarErrors, action.id);

  if (response.ok) {
    yield put(CarErrorsActions.carErrorsSuccess(action.id, response.data));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'dtcGet', title: 'Запрос ошибок DTC выполнен успешно'}));
  } else {
    const errorTitle = response.data && response.data.title ? response.data.title : response.problem;
    yield put(CarErrorsActions.carErrorsFailure(errorTitle));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: errorTitle}));
  }
}

export function * deleteCarErrors(api, action) {
  const response = yield call(api.deleteCarErrors, action.id);

  if (response.ok) {
    yield put(CarErrorsActions.carErrorsSuccess(action.id, null));
  } else {
    const errorTitle = response.data && response.data.title ? response.data.title : response.problem;
    yield put(CarErrorsActions.carErrorsFailure(errorTitle));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: errorTitle}));
  }
}

export function * getCarErrorsArchive(api, action) {
  const response = yield call(api.getCarErrorsArchive, {id: action.id, ...action.props});

  if (response.ok) {
    yield put(CarErrorsActions.carErrorsArchiveSuccess({...response.data, ...action.props}));
  } else {
    const errorTitle = response.data && response.data.title ? response.data.title : response.problem;
    yield put(CarErrorsActions.carErrorsFailure(errorTitle));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: errorTitle}));
  }
}
